import React from 'react';
import '../../styles/orderTracker.css';

const STEPS = [
  {
    key: 'pending',
    label: 'Order Confirmed',
    desc: 'Commission received & verified by Atelier concierge',
    icon: 'ri-file-list-3-line',
  },
  {
    key: 'processing',
    label: 'Atelier Crafting',
    desc: 'Handcrafted inspection & bespoke packaging',
    icon: 'ri-t-shirt-air-line',
  },
  {
    key: 'shipped',
    label: 'Dispatched with Courier',
    desc: 'En route via White-Glove dedicated transport',
    icon: 'ri-truck-line',
  },
  {
    key: 'delivered',
    label: 'Delivered to Sanctuary',
    desc: 'Safely presented to your destination',
    icon: 'ri-checkbox-circle-line',
  },
];

const OrderTracker = ({ status, trackingInfo, createdAt }) => {
  const normalizedStatus = (status || 'pending').toLowerCase();

  if (normalizedStatus === 'cancelled') {
    return (
      <div className="order-tracker__cancelled">
        <div className="order-tracker__cancelled-badge">
          <i className="ri-close-circle-line"></i> Commission Cancelled
        </div>
        <p className="order-tracker__cancelled-desc">
          This bespoke order has been archived upon request. No further charges or dispatches will take place.
        </p>
      </div>
    );
  }

  // Determine current step index
  let currentStepIndex = 0;
  if (normalizedStatus === 'processing') currentStepIndex = 1;
  else if (normalizedStatus === 'shipped') currentStepIndex = 2;
  else if (normalizedStatus === 'delivered') currentStepIndex = 3;

  return (
    <div className="order-tracker">
      <div className="order-tracker__header">
        <div className="order-tracker__title-wrap">
          <span className="order-tracker__kicker">LIVE ARTISAN TIMELINE</span>
          <h4 className="order-tracker__title">
            <i className="ri-compass-3-line"></i> Journey of Your Acquisition
          </h4>
        </div>

        {trackingInfo?.trackingNumber && (
          <div className="order-tracker__courier-badge">
            <i className="ri-shield-check-line text-warning"></i>
            <span>
              <strong>{trackingInfo.courierName || 'Atelier White-Glove'}</strong>: #{trackingInfo.trackingNumber}
            </span>
          </div>
        )}
      </div>

      <div className="order-tracker__stepper">
        <div
          className="order-tracker__line-fill"
          style={{ width: `${(currentStepIndex / (STEPS.length - 1)) * 100}%` }}
        />

        {STEPS.map((step, index) => {
          const isCompleted = index < currentStepIndex;
          const isCurrent = index === currentStepIndex;

          return (
            <div
              key={step.key}
              className={`order-tracker__step ${
                isCompleted ? 'completed' : isCurrent ? 'current' : 'upcoming'
              }`}
            >
              <div className="order-tracker__node">
                {isCompleted ? (
                  <i className="ri-check-line"></i>
                ) : (
                  <i className={step.icon}></i>
                )}
                {isCurrent && <span className="order-tracker__pulse-ring"></span>}
              </div>

              <div className="order-tracker__label-wrap">
                <span className="order-tracker__step-name">{step.label}</span>
                <span className="order-tracker__step-desc">{step.desc}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderTracker;
